export { default as HighlightedCriteriaView } from './HighlightedCriteriaView';
